import ButtonFavorite from 'components/ButtonFavorite'
import useFavori from 'hooks/useFavori'
import Favori from 'interfaces/Favori'
import cn from 'classnames'
import Card from '../Card'
import cardStyle from '../Card.module.scss'
import s from './CardFavori.module.scss'
import Checkbox from '../components/Checkbox'
import TruncatedCommentaire from '../components/TruncatedCommentaire'
import BtnModalUrlAnnonceCommentaire from '../components/BtnModalUrlAnnonceCommentaire'

interface Props {
  favori: Favori
  variant?: 'list' | 'map'
  count?: {
    index: number
    total: number
  }
  onClick?: () => void
  showCheckbox?: boolean
}

const defaultProps = {
  variant: 'map',
  count: undefined,
  onClick: () => null,
  showCheckbox: false,
}

const CardFavoris = ({
  favori,
  variant = 'map',
  count,
  onClick,
  showCheckbox,
}: Props): JSX.Element => {
  const { uidParcelle, createdAt, adresseParcelle } = favori
  const { checked, selected, commentaire, toggleChecked } =
    useFavori(uidParcelle)

  return (
    <div className={s.cardFavoriContainer}>
      {showCheckbox && (
        <Checkbox
          className={s.checkbox}
          checked={checked}
          onChange={toggleChecked}
        />
      )}
      <Card
        className={cn(s.cardFavori, s[variant], {
          [s.withCommentaire]: commentaire,
        })}
        onClick={onClick}
        selected={selected}
      >
        <Card.Title className={s.title}>{`Bien ${adresseParcelle}`}</Card.Title>
        <div className={s.btnAnnonceCommentaire}>
          <BtnModalUrlAnnonceCommentaire uid={uidParcelle} />
        </div>
        <span className={s.dateSaved}>
          Enregistré le {new Date(createdAt).toLocaleDateString()} en favoris
        </span>
        <ButtonFavorite className={s.btnFavorite} uid={uidParcelle} />
        <TruncatedCommentaire
          className={s.commentaire}
          commentaire={commentaire}
        />
        {count && (
          <div className={cn(cardStyle.cardCount, s.cardCount)}>
            {`${count.index} sur ${count.total}`}
          </div>
        )}
      </Card>
    </div>
  )
}

CardFavoris.defaultProps = defaultProps
export default CardFavoris
